<template>
	<svg
		class="status-icon"
		:class="`status-icon--${state}`"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		stroke-width="1.8"
		stroke-linecap="round"
		stroke-linejoin="round"
		aria-hidden="true"
	>
		<path v-if="state === 'confirming'" d="M21 12a9 9 0 1 1-9-9" />

		<template v-else>
			<circle cx="12" cy="12" r="9" />
			<path v-if="state === 'succeeded'" d="m8.2 12.4 2.6 2.6 5-5.6" />
			<path v-else d="M6.7 6.7 17.3 17.3" />
		</template>
	</svg>
</template>

<script setup lang="ts">
defineProps<{ state: 'confirming' | 'succeeded' | 'failed' }>()
</script>

<style lang="scss" scoped>
.status-icon {
	flex-shrink: 0;
	&--confirming {
		color: var(--text-tertiary);
		animation: status-icon-spin 0.9s linear infinite;
		// Человеку с prefers-reduced-motion вращение не показываем: дуга остаётся статичной.
		@media (prefers-reduced-motion: reduce) {
			animation: none;
		}
	}
	&--succeeded {
		color: var(--status-success);
	}
	&--failed {
		color: var(--status-error);
	}
}

@keyframes status-icon-spin {
	to {
		transform: rotate(360deg);
	}
}
</style>
